import React from "react";
import Form from "react-bootstrap/Form";

function InputField({
  field,
  label,
  value,
  onChange,
  error,
  type = "text",
  as = "Form.Group",
  pattern = null,
  controlId = "applicant",
  options = [], // Add this for select options
  disabled = false,
  min = "",
  required = true,
  allowCommas = false
}) {
  const handleInputChange = (e) => {
    let newValue = e.target.value;

    if (allowCommas) {
      const numericOnly = newValue.replace(/,/g, "").replace(/\D/g, "");
      newValue = numericOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else if (pattern === "^[0-9]*$") {
      newValue = newValue.replace(/\D/g, "");
    }

    onChange(field, newValue);
  };

  return (
    <Form.Group as={as} controlId={`${controlId}${field}`}>
      <Form.Label>{label}{required ? <span className="text-danger">*</span> : null}</Form.Label>
      {type === "select" ? ( // Check if type is "select"
        <Form.Select
          value={value}
          onChange={(e) => onChange(field, e.target.value)} // Pass the selected value
          isInvalid={!!error}
        >
          <option value="">Select {label}</option>
          {options.map((option, index) => {
            const optionValue = typeof option === "object" ? option.value : option;
            const optionLabel = typeof option === "object" ? option.label : option;
            return (
              <option key={index} value={String(optionValue)}>
                {optionLabel}
              </option>
            );
          })}
        </Form.Select>
      ) : (
        <Form.Control
          type={type}
          value={value}
          onChange={handleInputChange}
          isInvalid={!!error}
          pattern={type === "text" ? pattern : undefined}
          disabled={disabled}
          min={min}
        />
      )}
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </Form.Group>
  );
}

export default InputField;
